import React, { useEffect } from 'react';
import Typed from 'typed.js';
// 

function Home() {

    const TypedText = () => {
        useEffect(() => {
            // Options for Typed.js
            const options = {
                strings: ['Front-End Developer.', 'Back-End Develper.', 'Full-Stack Developer.'],
                typeSpeed: 50,
                backSpeed: 20,
                smartBackspace: true,
                loop: true,
                cursorChar: '_',
            };

            // Target the element where Typed.js will be applied
            const targetElement = document.getElementById('typed-text');

            // Create a new instance of Typed.js
            const typed = new Typed(targetElement, options);

            // Clean up the Typed.js instance on component unmount
            return () => {
                typed.destroy();
            };
        }, []); // Empty dependency array ensures useEffect runs only once after initial render

        return <span id="typed-text"></span>;
    };

    return (
        <>
            <div className='container-fluid pt-40 pb-24 md:pt-[15.5rem] md:pb-[15.5rem]' id='Home'>
                <div className="container">
                    <div className='intro-text md:font-medium text-3xl xl:text-6xl lg:text-6xl md:text-6xl sm:text-5xl xsm:ps-0 xsm:text-4xl lg:ps-10' data-aos="fade-right">
                        <h1 className='font-black'>Hi, I'm <span> Noman Ansari</span>.</h1>
                    </div>
                    <div className='typed-text py-[10px] xsm:ps-0 lg:ps-10 font-semibold sm:font-bold' data-aos="fade-right">
                        <TypedText />
                    </div>
                    <div className='Info-Details xl:ps-10 lg:ps-10 py-[10px] lg:w-5/6 xl:w-3/6 md:w-full text-justify md:ps-0 sm:ps-0 xsm:ps-0' data-aos="fade-right">
                        <p className='leading-relaxed tracking-wider'>I'm a FrontEnd Web Developer and I have Experience of <span>3 years</span>. I can provide you interactive, userfriendly and responsive Designed Website. I will provide your website by using <span>Html</span>,<span> CSS</span>,<span> BootStrap</span>,<span> TailwindCSS</span>,<span> JavaScript</span> &<span> React JS</span>.  I am passionate about my job, and if you hire me, I will work hard to meet your requirements and provide a good GUI (Graphical User Interface). If you have any questions, please contact me, and I would be pleased to answer them.</p>
                    </div>
                    <div className="btns py-[30px] flex flex-row justify-center md:justify-start lg:ps-10" data-aos="fade-right">
                        <a href='https://mail.google.com/mail/?view=cm&fs=1&to=nomanansarrii17@gmail.com&body=Hello!%20I%20want%20to%20hire%20you.' className="btn1 pt-[10px]" target='_blank'>Hire Me</a>
                        <a href='/contact' className="btn2 text-center pt-[10px]" target='_blank'>Let's Talk</a>
                    </div>
                    <div className='Icons space-x-5 pt-5 md:pt-[50px] flex flex-row justify-center md:justify-start lg:ps-10' data-aos="zoom-in">
                        <a className='Icon' href='https://web.whatsapp.com/send?phone=923237375911&text=Hello!%20I%20want%20to%20hire%20you.' target="_blank"><i className='bx bxl-whatsapp'></i></a>
                        <a className='Icon' href='https://instagram.com/inoman.dev' target="_blank"><i className='bx bxl-instagram' ></i></a>
                        <a className='Icon' href='https://www.linkedin.com/in/noman-ansari-15237028a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target="_blank"><i className='bx bxl-linkedin' ></i></a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home
